function Projects() {
    return (
        <svg version="1.1" className="w-5" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 472.615 472.615" >
        <g>
            <g>
                <path d="M19.692,49.231v295.385h433.231V49.231H19.692z M256,127.982h147.692v19.692H256V127.982z M315.077,177.213v19.692
                    h-29.538v-19.692H315.077z M265.846,177.213v19.692H147.692v-19.692H265.846z M236.308,147.675h-39.385v-19.692h39.385V147.675z
                    M177.231,78.752h49.231v19.692h-49.231V78.752z M68.923,78.752h88.615v19.692H68.923V78.752z M68.923,127.982h108.308v19.692
                    H68.923V127.982z M68.923,177.213H128v19.692H68.923V177.213z M68.923,226.444h88.615v19.692H68.923V226.444z M216.615,315.059
                    H68.923v-19.692h147.692V315.059z M226.462,246.136h-49.231v-19.692h49.231V246.136z M297.423,283.482L283.5,297.405
                    l-41.424-41.423l41.424-41.424l13.922,13.923l-27.5,27.5L297.423,283.482z M319.298,308.867l-18.288-7.308l39.385-98.462
                    l18.288,7.308L319.298,308.867z M376.192,297.405l-13.922-13.923l27.499-27.499l-27.499-27.5l13.922-13.923l41.424,41.424
                    L376.192,297.405z"/>
            </g>
        </g>
            <g>
                <path d="M0,364.308v22.646l24.221,36.431h424.172l24.222-36.431v-22.646H0z M206.769,403.675h-19.692v-19.692h19.692V403.675z
                    M246.154,403.675h-19.692v-19.692h19.692V403.675z M285.538,403.675h-19.692v-19.692h19.692V403.675z"/>
            </g>
        </svg>
    )
}

export default Projects